import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    '@global': {
        '.p-datatable': {
            display: 'flex',
            flexDirection: 'column',
            background: 'transparent',
        },
        '.p-datatable-wrapper': {
            overflow: 'auto',
        },

        // Header
        '.p-datatable .p-datatable-thead > tr > th': {
            padding: '16px 12px !important',
            fontSize: '14px !important',
            fontWeight: 700,
            background: 'transparent !important',
            borderWidth: '0 !important',
        },

        // Body
        '.p-datatable .p-datatable-tbody > tr > td': {
            padding: '12px 12px !important',
            fontSize: '14px !important',
            verticalAlign: 'middle',
            borderWidth: '0 !important',
        },

        // Zebra
        '.p-datatable .p-datatable-tbody > tr:nth-of-type(odd)': {
            backgroundColor: `${theme.palette.grey[100]} !important`,
        },
        '.p-datatable .p-datatable-tbody > tr:nth-of-type(even)': {
            backgroundColor: `${theme.palette.grey[200]} !important`,
        },

        // Paginator
        '.p-datatable .p-paginator': {
            display: 'flex !important',
            alignItems: 'center !important',
            gap: '16px !important',
            marginTop: '8px !important',
            fontSize: '14px !important',
            background: 'transparent !important',
            border: 'none !important',
        },
        '.p-paginator-left, .p-paginator-right': {
            display: 'flex !important',
            alignItems: 'center !important',
            gap: '8px !important',
        },
        '.p-paginator-pages': {
            maxWidth: '240px !important',
            overflow: 'hidden !important',
            whiteSpace: 'nowrap !important',
            textOverflow: 'ellipsis !important',
        },

        // Rows-per-page Dropdown
        '.p-dropdown': {
            border: 'none !important',
            marginLeft: '8px !important',
        },
        '.p-dropdown .p-dropdown-label': {
            fontSize: '14px !important',
        },
        '.p-datatable .p-datatable-tbody > tr > td': {
            background: 'transparent !important',
        },

        '.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd) > td': {
            backgroundColor: '#f5f5f5 !important',
        },
        '.p-datatable-striped .p-datatable-tbody > tr:nth-child(even) > td': {
            backgroundColor: 'transparent !important',
        },

        '.p-datatable .p-datatable-tbody > tr:hover > td': {
            filter: 'brightness(0.98)',
        },
    },

    footerButtonWrapper: {
        display: 'flex',
        gap: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5),
    },
    numberPageBtn: {
        border: '1px solid lightgrey',
        borderRadius: theme?.dimensions?.borderRadiusInput,
        cursor: 'pointer',
    },
    movePageBtn: {
        cursor: 'pointer',
        borderRadius: theme?.dimensions?.borderRadiusInput,
        padding: theme.spacing(0.5, 1),
    },
    rppWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),

        '& label': {
            marginBottom: 0,
        },
    },
}));
